module.exports = __webpack_public_path__ + "img/N550-2-EN.c814a36d.png";